<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10 6C9.44772 6 9 6.44772 9 7V11.5858L8.20711 10.7929C7.81658 10.4024 7.18342 10.4024 6.79289 10.7929C6.40237 11.1834 6.40237 11.8166 6.79289 12.2071L9.29289 14.7071C9.68342 15.0976 10.3166 15.0976 10.7071 14.7071L13.2071 12.2071C13.5976 11.8166 13.5976 11.1834 13.2071 10.7929C12.8166 10.4024 12.1834 10.4024 11.7929 10.7929L11 11.5858V7C11 6.44772 10.5523 6 10 6Z"
  />
</svg>
